import { useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { reloadIfOutdated } from '../lib/app-version';
import { useI18n } from '../lib/i18n';
import { Button, LoadingBlock } from '../components/ui';

/**
 * An address Finance has no page for. A tab opened before a deploy does not
 * know the pages the deploy added, and a notification links to one at once — so
 * the page first asks which build the server hands out now and loads it if it
 * is newer (`lib/app-version.ts`). Only then does it say there is nothing here.
 */
export function NotFoundPage() {
  const { t } = useI18n();
  const { pathname } = useLocation();
  const [checked, setChecked] = useState<string | null>(null);

  useEffect(() => {
    let live = true;
    void reloadIfOutdated().then((reloading) => {
      if (live && !reloading) setChecked(pathname);
    });
    return () => {
      live = false;
    };
  }, [pathname]);

  if (checked !== pathname) return <LoadingBlock />;
  return (
    <div className="grid place-items-center py-24 text-center">
      <p className="font-display text-mega text-primary/30">404</p>
      <p className="mt-2 text-h2 text-[var(--text-primary)]">{t('common.noResults')}</p>
      <p className="mt-1 text-body-sm text-muted">{t('common.notFoundHint')}</p>
      <Link to="/" className="mt-5">
        <Button variant="primary">{t('nav.dashboard')}</Button>
      </Link>
    </div>
  );
}
